module.exports = __webpack_public_path__ + "img/8A.dc2aee6f.png";